export enum EEnvironment {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  QA = 'QA',
  PRODUCTION = 'PROD',
  VITEST = 'test',
}
